<template>
<div class="error">
    <div class="text">二维码已失效，请重新扫码</div>

</div>
</template>

<script>
export default {
    name: "error"
}
</script>

<style scoped>

.error {
    font-size: 20px;
    width: 100%;
    height: 100%;
    justify-content: center;
    display: flex;
}
.text {
    align-self: center;
    text-align: center;
}

</style>
